import { FilledInput, InputAdornment, Popover } from '@mui/material';
import { Fragment, SetStateAction, useState } from "react";
import SearchIcon from "../../assets/images/Search.svg";

import "./SearchableDown.scss";

function SearchableDown(props: {
    open: boolean; anchorEl: HTMLImageElement;
    onClose: (value: string) => void; onClick: CallableFunction; initialDetails: string[]; searchable: boolean
}) {

    const [searchField, setSearchField] = useState("");

    const handleChange = (e: { target: { value: SetStateAction<string>; }; }) => {
        setSearchField(e.target.value);
    };

    function SearchList(prop: { filteredPersons: any }) {

        const filtered = prop.filteredPersons.map((value: any, key: number) => <Card key={key} text={value} />);

        return (<div>{filtered}</div>);
    }

    function Card(prop: { text: string; }) {
        return (
            <div onClick={(value: any) => { props.onClick(prop.text); }} className="item">
                {prop.text}
            </div>
        )
    }

    const Scroll = (props: { children: any }) => {
        return (
            <div style={{ overflowY: 'scroll', maxHeight: '20vh' }}>
                {props.children}
            </div>
        );
    }

    const filteredSearch = props.initialDetails.filter(data => {
        return (data?.toLowerCase().includes(searchField?.toLowerCase()));
    });

    function searchList() {
        return (
            <Scroll>
                <SearchList filteredPersons={filteredSearch} />
            </Scroll>
        );
    }

    return (
        <Popover classes={{ paper: "propover" }} open={props.open} anchorEl={props.anchorEl} onClose={props.onClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }} transformOrigin={{ vertical: 'top', horizontal: 'left', }}>
            <div className="drp-search-container">
                {
                    props.searchable
                        ? <FilledInput id="filled-adornment" disableUnderline={true} type={"text"} placeholder={"Search"}
                            classes={{ root: "search-container", input: "input" }} onChange={handleChange}
                            startAdornment={
                                <InputAdornment classes={{ root: "img-container" }} position="end">
                                    <img className="img" src={SearchIcon} alt={"Search"} />
                                </InputAdornment>
                            }
                        />
                        : <Fragment />
                }
                {searchList()}
            </div>
        </Popover >
    )
}


export default SearchableDown